<template>
    <div class="menu-home h-[60px] flex items-center grow text-center" v-click-outside="doUnroll">
        <div class="menu-home-sub hidden *:block lg:flex items-center" :class="{mobile: unroll}">
            <a class="px-2.5 leading-[60px]" href="#home-slide-jobs">{{ gettext("A qui s'adresse Octolo") }}</a>
            <a class="px-2.5 leading-[60px]" href="#home-slide-features">{{ gettext("Nos fonctionnalités") }}</a>
            <a class="px-2.5 leading-[60px]" href="#home-slide-security">{{ gettext("Sécurité & Confidentialité") }}</a>
            <a class="px-2.5 leading-[60px]" href="#home-slide-prices" tabindex="-1" aria-disabled="true">{{ gettext("Nos formules") }}</a>
            <!-- <a class="px-2.5 leading-[60px] habitat" href="/habitat/">{{ gettext("Octolo habitat") }}</a> -->
            <a class="px-2.5 leading-[60px] habitat" href="/contact/">{{ gettext("Contactez nous") }}</a>
            <a class="px-2.5 leading-[60px] habitat" href="https://blog.octolo.tech/" target="_blank">{{ gettext("Ressources") }}</a>
        </div>
        <div class="block lg:hidden grow" />
        <div class="flex">
            <Burger class="leading-[60px] w-[60px] text-center lg:hidden block text-xl" @click="doRoll" />
            <a class="myaccount obtn secondary leading-[50px]" href="/login">
                <span class="px-[5px]">
                    <b>{{ gettext("Mon compte")}}</b>
                </span>
                <fa icon="user" />
            </a>
        </div>
    </div>
</template>

<script>
import Burger from '@/toremove/components/octolo/menu/Burger.vue';

export default {
  name: 'menu-home',
  components: { Burger },
}
</script>

<style lang="scss">
@import "@/assets/v2/octolo/homepage.scss";
</style>
